(function () {
  var solidClass = 'arovias-header-solid';
  var transparentClass = 'arovias-header-transparent';
  var threshold = 36;

  function syncHeaderState() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    var isSolid = window.scrollY > threshold;
    document.body.classList.toggle(solidClass, isSolid);
    document.body.classList.toggle(transparentClass, !isSolid);
  }

  window.addEventListener('scroll', syncHeaderState, { passive: true });
  window.addEventListener('resize', syncHeaderState);
  document.addEventListener('DOMContentLoaded', syncHeaderState);
  syncHeaderState();
})();
